import {config} from "../config";
import {handleResponse} from "../helpers/response";
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import UIkit from 'uikit';
import {clearCountAddToCart} from "./item";

export const RECEIVED_CART_INFO = 'RECEIVED_CART_INFO';
export const RECEIVED_COMPARE_INFO = 'RECEIVED_COMPARE_INFO';
export const RECEIVED_WISH_INFO = 'RECEIVED_WISH_INFO';
export const HIDE_CART_COMPARE_LOADER='HIDE_CART_COMPARE_LOADER';
export const SHOW_CART_COMPARE_LOADER = 'SHOW_CART_COMPARE_LOADER';
export const SET_COMPARE_DEEP_DATA = 'SET_COMPARE_DEEP_DATA';
export const CHANGE_COMMENT_ACTION = 'CHANGE_COMMENT_ACTION';
export const CHANGE_PRESENT_COMMENT_ACTION='CHANGE_PRESENT_COMMENT_ACTION';
export const CLEAR_ITEM_COMMENT='CLEAR_ITEM_COMMENT';
/**
 * Reload wish data after adding.
 *
 * @param id
 * @returns {function(...[*]=)}
 */
export function addToWish(id){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/wishlist/add/";
        const formData  = new FormData();
        dispatch(showLoader());
        formData.append("product_id", id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, { method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(showLoader());
            dispatch(getsWishData());
            dispatch(hideLoader());
            UIkit.notification(i18n.t('shop.addedToWish'), {timeout: 1000})
        })
    }
}

export function removeFromWish(id) {
    return (dispatch, getState) => {
        const formData = new FormData();
        dispatch(showLoader());
        formData.append("good_id", id);
        var link = config.apiUrl + 'api/wishlist/remove/';
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(showLoader());
            dispatch(getsWishData());
            dispatch(hideLoader());
            UIkit.notification(i18n.t('shop.removedFromWish'), {timeout: 1000})
        })

    }
}


/**
 * Gets cart wish data
 *
 * @returns {function(...[*]=)}
 */
export function getsCartData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/cart/get/";
        dispatch(showLoader());
        fetch(link).then( handleResponse ).then( json => {
            // console.log("json 326", json);
            dispatch(setCartData(json));
            dispatch(hideLoader());
        });
    }
}

/**
 *
 *
 * @returns {{type: string, showItemLoader: boolean}}
 */
export function hideLoader(){
    return {
        type: HIDE_CART_COMPARE_LOADER,
    }
}

/**
 * Shows loader
 *
 * @returns {{type: string, showItemLoader: boolean}}
 */
export function showLoader(){
    return {
        type: SHOW_CART_COMPARE_LOADER,
    }
}

/**
 * Sets cart data
 *
 * @param data
 * @returns {{countCart: *, type: string}}
 */
export function setCartData( data ){
    return {
        type: RECEIVED_CART_INFO,
        data: data
    }
}


export function getsCompareData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/ua/comparelist/count/';
        dispatch(showLoader());
        fetch(link).then(handleResponse).then( json => {
            // console.log("json 3838383838" , json );
            dispatch(setCompareData(json));
            dispatch(hideLoader());
        })
    }
}

/**
 * Set compare data action
 *
 * @param data
 * @returns {{countWish: *, type: string}}
 */
export function setCompareData(data){
    return {
        type: RECEIVED_COMPARE_INFO,
        data: data
    }
}

export function getsWishData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/wishlist/count/";
        dispatch(showLoader());
        fetch(link).then(handleResponse).then(json => {
            dispatch(setWishData(json));
            dispatch(hideLoader());
        });
    }
}

export function addToCompare(id){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/comparision/add/";
        const formData  = new FormData();
        dispatch(showLoader());
        formData.append("product_id", id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, { method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(showLoader());
            dispatch(getsCompareData(id));
            dispatch(hideLoader());
            UIkit.notification(i18n.t('shop.addedToCompare'), {timeout: 1000})
        })
    }
}

export function removeFromCompare(id){
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl + "api/compare/remove/";
        const formData = new FormData();
        formData.append('good_id', id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(showLoader());
            dispatch(getsCompareData(id));
            dispatch(loadDeepData())
            dispatch(hideLoader());
            UIkit.notification(i18n.t('shop.removedFromCompare'), {timeout: 1000})
        });
    }
}


/**
 * Set wish data action
 *
 * @param data
 * @returns {{countWish: *, type: string}}
 */
export function setWishData(data){
    return {
        type: RECEIVED_WISH_INFO,
        data: data
    }
}


export function changeComment( comment, itemId ) {
    return {
        type: CHANGE_COMMENT_ACTION,
        comment: comment,
        item: itemId
    }
}

export function updateCommentInCartData(comment, itemId){
    return {
        type: CHANGE_PRESENT_COMMENT_ACTION,
        comment: comment,
        item: itemId
    }
}

/**
 * triggers api update comments
 *
 * @param id
 * @returns {function(...[*]=)}
 */
export function triggerApiUpdateComment(id, uniqueId){
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl+"api/cart/update/comment/"+uniqueId;
        const formData = new FormData();
        formData.append("comments", getState().wishCompareCart.cartData.data[id]['comments']);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link,{method: 'POST', body: formData}).then(handleResponse).then(()=>{
            dispatch(hideLoader());
            UIkit.notification({"message":"Saved"})
        });
    }
}

/**
 *
 * @param id
 * @param comment
 * @returns {function(...[*]=)}
 */
export function addToCart( id, isSendComment = true){
    // console.log("IDIDIDIDIDIDI ", id);
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl + "api/cart/add/";
        const formData  = new FormData();


        // console.log("visSendCommentisSendComment ", isSendComment );
        formData.append("good_id", id);
        if (isSendComment) {
            formData.append('comments', getState().wishCompareCart.commentsItems[id] !== undefined ? getState().wishCompareCart.commentsItems[id] : '');
        }
        formData.append('count', getState().goodItem.countProductsToAdd);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, { method: 'POST', body: formData} ).then(handleResponse).then(json => {
            dispatch(getsCartData());
            dispatch(hideLoader());
            dispatch(clearCountAddToCart());
             UIkit.notification(i18n.t('shop.addedToCart'), {timeout: 1000})
        })
    }
}

export function loadDeepData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/comparelist/deepdata/'+i18n.language;
        fetch(link).then(handleResponse).then(json => {
            dispatch(setDeepData(json));
            dispatch(hideLoader());
        })
    }
}

export function clearItemComments(){
    return {
        type: CLEAR_ITEM_COMMENT
    }
}

/**
 * sets deep data
 *
 * @param json
 * @returns {{data: *, type: *}}
 */
export function setDeepData(json) {
    return {
        type: SET_COMPARE_DEEP_DATA,
        data: json
    }
}


